import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-300 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-[#18181b] p-8 rounded-2xl border border-white/5 shadow-xl">
        <h1 className="text-3xl font-bold tracking-tight text-white mb-8" style={{ fontFamily: 'Cabinet Grotesk' }}>
          Privacy Policy
        </h1>
        
        <div className="space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Information We Collect</h2>
            <p>
              We collect information that you voluntarily provide to us when you use our Instagram messaging automation service. This includes:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Your Instagram profile information (username, name)</li>
              <li>Messages sent to and from our automated systems</li>
              <li>Basic analytics on messaging interactions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. How We Use Your Information</h2>
            <p>
              We use the information we collect primarily to provide, maintain, and improve our automation services. Specifically, we use your data to:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Process and respond to your Instagram Direct Messages automatically</li>
              <li>Provide customer support and conversational experiences via AI</li>
              <li>Analyze usage to improve our chatbot responses and features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Data Sharing and Meta Integrations</h2>
            <p>
              Our application uses the Instagram Graph API and Meta Developer tools to function. Your data is processed securely through Meta's official APIs. We do not sell your personal data to third parties. Data is only shared as necessary to operate the service and comply with the law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Data Deletion and Your Rights</h2>
            <p>
              You have the right to request the deletion of your personal data. If you wish to have your data removed from our systems, or if you want to stop interacting with our automated services, you can:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Contact us directly through our official Instagram page</li>
              <li>Email us at support@thefounderzhub.com</li>
            </ul>
            <p className="mt-2">
              We will process data deletion requests in accordance with applicable privacy laws and Meta's platform policies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at support@thefounderzhub.com.
            </p>
          </section>
          
          <div className="pt-6 mt-8 border-t border-white/5 text-xs text-zinc-500">
            Last Updated: {new Date().toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
